module.exports = __webpack_public_path__ + "static/icon-tail.2717209e.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/festival/icon-tail.png
// module id = 125
// module chunks = 2